<template>
    <div class="hts-user flex items-center">
        <template v-if="CShowPopup">
            <hts-tooltip>
                <template #reference>
                    <hts-avatar
                        class="hts-user__avatar"
                        :type="type"
                        :src="avatarUrl"
                        :size="size"
                        :editable="editable"
                        @click="$emit('avatar-click', $event)" />
                </template>
                <div class="hts-user__information-popup">
                    <slot name="info">
                        <p class="hts-user__information--label">
                            {{ fullName || fetchUser.fullName }}
                        </p>
                        <p class="hts-user__information--description">
                            {{ jobTitle }}
                        </p>
                    </slot>
                </div>
            </hts-tooltip>
        </template>
        <template v-else>
            <hts-avatar
                class="hts-user__avatar"
                :type="type"
                :src="avatarUrl"
                :size="size"
                :editable="editable"
                @click="$emit('avatar-click', $event)" />
            <div
                v-if="inline"
                class="leading-none ml-1 font-medium">
                {{ fullName || fetchUser.fullName }}
            </div>
            <div
                v-else-if="showInfo"
                class="hts-user__information"
                :class="informationCls">
                <slot name="info">
                    <p class="hts-user__information--label">
                        {{ fullName || fetchUser.fullName }}
                    </p>
                    <p class="hts-user__information--description">
                        {{ jobTitle }}
                    </p>
                </slot>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, toRefs, onMounted } from 'vue'

const props = defineProps({
  id: String,
  type: String,
  size: String,
  editable: Boolean,
  showInfo: Boolean,
  inline: Boolean,
  showPopup: Boolean
})

const defaultAvatarUrl = ref('/assets/default-avatar.png')
const { id, size, editable, inline, showInfo, showPopup } = toRefs(props)
const { system } = $store()
const users: any[] = system.workspaceUsers

const fetchUser = ref({ fullName: '', jobTitle: '', avatar: '' })

// Kiểm tra xem user có trong danh sách workspaceUsers hay không
const user = computed(() => {
  return users.find((u) => u._id === id?.value) || null
})

// Lấy thông tin user ưu tiên theo thứ tự: `user` (nếu có) -> `fetchUser` (nếu đã fetch) -> giá trị mặc định
const fullName = computed(() => user.value?.fullName || fetchUser.value.fullName || '')
const jobTitle = computed(() => user.value?.jobTitle || fetchUser.value.jobTitle || '')
const avatarUrl = computed(() => user.value?.avatar || fetchUser.value.avatar || defaultAvatarUrl.value)

const CShowPopup = computed(() => (inline.value ? false : showPopup.value))

const informationCls = computed(() => {
  switch (size?.value) {
  case 'mini':
    return 'text-sm'
  case 'large':
    return 'text-large'
  default:
    return ''
  }
})

const getData = async () => {
  if (user.value) {
    // Nếu user đã có trong workspaceUsers, không cần gọi API nữa
    return
  }

  if (!id?.value) {
    fetchUser.value = { fullName: '', jobTitle: '', avatar: '' }
    return
  }

  try {
    const api = {
      url: '/auth/company-user/public/info',
      method: 'post'
    }
    const data = await $api(api, { body: { id: id?.value } })
    const resData: any = $lodash.get(data, 'data.value')

    if (resData?.success) {
      fetchUser.value = {
        fullName: resData.data.fullName,
        jobTitle: resData.data.jobTitle,
        avatar: resData.data.avatar
      }
    } else {
      fetchUser.value = { fullName: '', jobTitle: '', avatar: '' }
    }
  } catch (error) {
    fetchUser.value = { fullName: '', jobTitle: '', avatar: '' }
  }
}

onMounted(() => {
  getData()
})
</script>
